import React, { useState } from "react";
import LiveQuizzes from "./LiveQuizzes";
import PracticeQuizzes from "./PracticeQuizzes";

const StudentQuizDetails = ({ selectedSchool }) => {
  const [activeTab, setActiveTab] = useState("live");

  return (
    <div className="container-fluid px-5 py-3">
      <div className="mb-3">
        <button
          className={`btn me-2 ${
            activeTab === "live" ? "btn-primary" : "btn-outline-primary"
          }`}
          onClick={() => setActiveTab("live")}
        >
          Live Quizzes
        </button>
        <button
          className={`btn ${
            activeTab === "practice" ? "btn-primary" : "btn-outline-primary"
          }`}
          onClick={() => setActiveTab("practice")}
        >
          Practice Quizzes
        </button>
      </div>
      {activeTab === "live" && <LiveQuizzes selectedSchool={selectedSchool} />}
      {activeTab === "practice" && (
        <PracticeQuizzes selectedSchool={selectedSchool} />
      )}
    </div>
  );
};

export default StudentQuizDetails;
